import { EvalScope, EvalScopeOptions, ParentScope } from '../scope/index.js';

import { SchemaField as SchemaFieldDef } from './types.js';

export interface SchemaFieldOptions extends EvalScopeOptions {
  fallbackKey?: string;
}

const defaultOptions: Required<SchemaFieldOptions> = {
  include: ['min', 'max', 'step', 'default', 'value'],
  evaluate: false,
  fallbackKey: 'default',
};

export class SchemaField<
  TSchemaField extends SchemaFieldDef,
  TSchemaParent extends ParentScope = never
> extends EvalScope<TSchemaField, TSchemaParent> {
  declare options: Required<SchemaFieldOptions>;

  constructor(field: TSchemaField, name: string, parent: TSchemaParent, opts?: SchemaFieldOptions) {
    const evaluate =
      opts?.evaluate ?? (field.type === 'number' || field.type === 'boolean') ?? false;

    super(field, name, parent, {
      ...defaultOptions,
      ...opts,
      evaluate,
    });
  }

  get(key: string, bubble = true): any {
    if (key === 'value') {
      return super.get(key, bubble) ?? super.get(this.options.fallbackKey, bubble);
    }

    return super.get(key, bubble);
  }

  has(key: string) {
    return key === 'value' || super.has(key);
  }
}
